import React from "react";
import { useRestaurant } from "../../../utils/contexts/restaurant-context";
import BeveragesContent from "./BeveragesContent";

export default function TabsAlibi() {
    const { restaurant } = useRestaurant();

    const [isSearching, setIsSearching] = React.useState(false);
    const [result, setResult] = React.useState([]);

    return (
        <BeveragesContent
            beverages={restaurant.beverages}
            isSearching={isSearching}
            result={result}
            hasOrders={false}
            setResult={setResult}
            setIsSearching={setIsSearching}>
        </BeveragesContent>
    );
}

